
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class SendCampaignDetailsDialog extends Serenity.EntityDialog<SendCampaignDetailsRow, any> {
        protected getFormKey() { return SendCampaignDetailsForm.formKey; }
        protected getIdProperty() { return SendCampaignDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return SendCampaignDetailsRow.localTextPrefix; }
        protected getService() { return SendCampaignDetailsService.baseUrl; }
        protected getDeletePermission() { return SendCampaignDetailsRow.deletePermission; }
        protected getInsertPermission() { return SendCampaignDetailsRow.insertPermission; }
        protected getUpdatePermission() { return SendCampaignDetailsRow.updatePermission; }

        protected form = new SendCampaignDetailsForm(this.idPrefix);

    }
}